import { sentenceCase } from 'change-case';

// Colours for the workflow's UPPER_CASE enums, shared by every workflow screen.

export const STATUS_COLORS = {
  PENDING_APPROVAL: 'warning',
  APPROVED: 'info',
  IN_TRANSIT: 'info',
  IN_REPAIR: 'info',
  PENDING_RECEIPT: 'warning',
  COMPLETED: 'success',
  RETURNED: 'error',
  REJECTED: 'error',
};

export const RATING_COLORS = { GREEN: 'success', AMBER: 'warning', RED: 'error', UNKNOWN: 'default' };

export const TYPE_LABELS = {
  TRANSFER: 'Transfer',
  DISPOSAL: 'Disposal',
  REPAIR: 'Maintenance',
  REGULARIZATION: 'Regularization',
};

/** `PENDING_APPROVAL` -> `Pending approval`. */
export const humanize = (value) => (value ? sentenceCase(String(value).toLowerCase()) : '');
